import * as React from 'react';
import { Modal } from '@cian/ui-kit/prev';
import { Button } from '@cian/ui-kit/button';
import { parsePhoneNumber } from '../../utils/strings';

import * as styles from './ShowPhone.css';

export interface IShowPhoneProps {
  name?: string | null;
  withNote: boolean;
  phones: string[];
  trackClick(): void;
}

export const ShowPhone = (props: IShowPhoneProps) => {
  const { name, withNote, phones, trackClick } = props;
  const onClick = React.useCallback((event: React.MouseEvent) => {
    event.stopPropagation();
  }, []);

  return (
    <div onClick={onClick}>
      <Modal
        onClick={trackClick}
        master={
          <Button theme="fill_primary" size="XS">
            Показать телефон
          </Button>
        }
      >
        <div>
          <p className={styles['name']}>{name}</p>
          {phones.map(phone => (
            <div key={phone} className={styles['phone']}>
              {parsePhoneNumber(phone)}
            </div>
          ))}
          {withNote && <p className={styles['note']}>Сообщите владельцу, что вы нашли это объявление на ЦИАН.</p>}
        </div>
      </Modal>
    </div>
  );
};
